import Config from "./config";

export function applyTheme() {
  const defaultTheme = themeMap["default"];
  const root = document.documentElement;
  Object.entries(defaultTheme.variables).forEach(([key, value]) => {
    console.log("working");
    root.style.setProperty(key, value);
  });

  // applying some config over default theme
  const themeKey = Config.siteTitle;
  const theme = themeMap[themeKey];
  if (!theme) return;

  Object.entries(theme.variables).forEach(([key, value]) => {
    root.style.setProperty(key, value);
  });
}




const themeMap = {
  default: {
    name: "Default Theme",
    variables: {
      // Background colors
      "--background-primary": "#fff",
      "--background-secondary": "#F2F2F7",
      "--background-tertiary": "#e9ecef",
      "--background-light": "#D5DDF9",
      "--background-card": "#fff",
      "--background-learning": "#f6f6f6",
      "--background-hover": "#efefef",
      
      // Text colors
      "--text-primary": "#1A2845",
      "--text-secondary": "#303030",
      "--text-tertiary": "#333",
      "--text-muted": "#78849E",
      "--text-medium-gray": "#66686C",
      "--text-dark-gray": "#343A40",
      "--text-white": "#fff",
      "--text-learning-blue": "#3153cd",
      "--text-learning-gray": "#aeaeb2",
      "--text-learning-course": "#1e4471",
      "--text-black": "#000000",
      
      // Button colors
      "--button-primary": "#1A2845",
      "--button-secondary": "#264FE0",
      "--button-tertiary": "#2A55DC",
      "--button-accent": "#2a5bd7",
      "--button-strong": "#3454d1",
      "--button-light": "#4383c2",
      "--button-dark": "#132461",
      "--button-alternate": "#214D99",
      
      // Border colors
      "--border-primary": "#e0e0e0",
      "--border-secondary": "#e5e5e5",
      "--border-heavy": "#DDDDDD",
      "--border-button": "#1A2845",
      "--border-accent": "#D5DDF9",
      "--border-learning": "#f6f6f6",
      "--border-active": "#339af0",
      "--border-course": "#1e4471",
      
      // Status colors
      "--success-color": "#28a745",
      "--success-bright": "rgb(45, 227, 45)",
      "--warning-color": "orange",
      "--error-color": "#e74c3c",
      "--error-bright": "red",
      "--info-color": "#2a5bd7",
      "--teal-color": "#609281",
      "--turquoise-color": "rgb(34, 211, 170)",
      
      // Interactive colors
      "--hover-primary": "#e6e6e6",
      "--active-blue": "rgb(213, 221, 249)",
      "--active-blue-text": "rgb(66, 94, 146)",
      "--focus-blue": "rgba(0, 123, 255, .25)",
      "--stroke-primary": "#3153CD",
      "--stroke-black": "#000000",
      "--sidebar-primary": "#dde3fa",
      "--sidebar-accent": "#3f51b5",
      "--sidebar-icon": "#6287e6",
      "--sidebar-success": "#1de9b6",
      
      // Typography
      "--font-heading": "'Poppins', sans-serif",
      "--font-body": "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
      
      // Font sizing
      "--font-h1-size": "32px",
      "--font-h2-size": "24px",
      "--font-h3-size": "21px",
      "--font-body-size": "16px",
      "--font-small-size": "14px",
      "--border-radius": "8px",
      "--border-radius-medium": "0.5rem",
      "--section-padding": "16px",
      
      // Shadows
      "--shadow-light": "rgba(202,214,224,0.5)",
      "--shadow-medium": "rgba(0,0,0,.125)",
      "--shadow-heavy": "rgba(0,0,0,.175)",
      "--shadow-overlay": "#12121233",
      
      // Opacity
      "--opacity-disabled": "0.4",
      "--opacity-semi": "0.7",
      "--opacity-light": "0.8",
    },
  },

  psb: {
    name: "PSB Theme",
    variables: {
      // Button colors
      "--button-secondary": "#B30537",
      "--button-hover": "#c30937",
      "--button-light": "#FFE8EE",
      
      // Background colors
      "--background-primary": "#FAFAFA",
      "--background-table": "#F3F3F3",
      
      // Status colors
      "--warning-color": "#FFA535",
      "--success-color": "#027E46",
      "--error-color": "#D52A23",
      "--error-bright": "#FB3836",
      
      // Text colors
      "--text-dark": "#242731",
      "--text-gray": "#1F2937",
      "--text-icon": "#343330",
      "--text-base": "#706E6B",
      "--text-secondary": "#606A70",
      "--text-black": "#080707",
      "--text-muted": "#3E3E3C",
      
      // Border colors
      "--border-primary": "#D9D9D9",
      "--border-table": "#E3E5E8",
      
      // Link and interactive colors
      "--link-primary": "#1589EE",
      "--link-light": "#e6f2fd",
      "--link-secondary": "#116ACC",
      "--tooltip-background": "#16325C",
      
      // Typography
      "--font-primary": "'Lato', sans-serif",
      "--font-secondary": "'Lato', sans-serif",
      
      // Shadow colors
      "--shadow-modal": "rgba(62, 62, 60, 0.25)",
    },
  },
};

export default themeMap;